<template>
  <div class="wrapper">
    <div class="user_bg">
      <div class="user_list">
        <span>
          <span>患者姓名</span>
          {{ report.patientName }}（{{ report.sex == "M"?"男":"女" }}）
        </span>
        <span>
          <span>患者编号</span>
          就诊ID号&nbsp;&nbsp;
          {{ report.patientId }}
        </span>
      </div>
    </div>
    <div class="content">
      <div class="cont_title">检验明细<span style="font-weight: normal;"></span></div>
      <div class="cont_list">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item :name = 1 >
            <template #title>
              <div class="taocan">
                <span>{{ report.checkTypeName }}</span>
                <!-- <span>{{ item.dfVremark == "ItemSet"?"套餐":"项目" }}</span>
                <span class="jiage">{{ item.dfVmoney }}￥</span> -->
              </div>
            </template>
            <ul class="item_list">
              <li class="item_title">
                <span>项目名称</span>
                <span>检查结果</span>
                <span>单位</span>
                <span>参考值</span>
                <span>提示</span>
              </li>
              <li v-for="item in jyreport.lstItemResult" :key="item.ItemID">
                <span>{{ item.ItemName }}</span>
                <span>{{ item.ItemResult }}</span>
                <span>{{ item.ItemUnit }}</span>
                <span>{{ item.ItemRefer }}</span>
                <span>{{ item.ItemPromt }}</span>
              </li>
            </ul>
            <!-- <ul class="tableCl">
              <li class="mmhh">
                <span>项目名称</span>
                <span>项目类型</span>
              </li>
              <li v-for="(it, dex) in item.itemlist" :key="dex">
                <span>{{ it.djDItemName }}</span>
                <span>{{ it.dpName }}</span>
              </li>
            </ul> -->
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <div class="foot">
      <span>
        <span>报告医生</span>
        <span>{{ jyreport.Reviewer }}</span>
      </span>
      <span>
        <span>报告时间</span>
        <span>{{ jyreport.AudiTime }}</span>
      </span>
      <span>
        <span>报告编号</span>
        <span>{{ jyreport.LabNo }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { GetCkLabDtlResult } from "@/request/api.js";
export default {
  data() {
    return {
      report: {},
      jyreport: {},
      activeNames: 1,
    }
  },
  created() {
    this.report = JSON.parse(sessionStorage.getItem("report"));
    this.getjyReport();
  },
  methods: {
    async getjyReport(){
      let map = {
        billNo: this.report.billNo,
        type: this.report.applyType,
        userID: "7148"
      }
      let res = await GetCkLabDtlResult(map);
      if(res.data.ResultData != null){
        this.jyreport = res.data.ResultData[0];
        this.jyreport.AudiTime = this.jyreport.AudiTime.replace(/\-/g, "/")
      } else {
        this.Toast(res.data.ResultMsg)
      }
    }
  },
}
</script>

<style lang="less" scoped>
  .wrapper {
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #f8f8f8;
    .user_bg{
      background: white;
      padding: 16px;
      .user_list{
        background: #e6f5fc;
        border-radius: 4px;
        display: flex;
        flex-flow: column nowrap;
        padding: 16px 10px;
        font-size: 16px;
        >span{
          >span{
            font-weight: bold;
            letter-spacing: 1px;
            color: #888;
            margin-right: 6px;
          }
        }
        >span:nth-child(1){
          margin-bottom: 6px;
        }
      }
    }
    .content{
      background: white;
      margin-top: 10px;
      .cont_title{
        letter-spacing: 1px;
        padding: 12px 16px;
        font-weight: bold;
        font-size: 16px;
        border-bottom: 1px solid #ddd;
      }
      /deep/ .cont_list{
        // padding: 0px 16px;
        .van-cell{
          background: #f2f3f5;
          align-items: center;
        }
        .van-collapse-item__content{
          padding: 0px;
          .item_list{
            >li{
              display: flex;
              flex-flow: row nowrap;
              text-align: center;
              border-bottom: 1px solid #ddd;
              align-items: center;
              >span{
                padding: 10px 0px;
                width: 20%;
                // border-left: 1px solid #ddd;
                color: black;
              }
              >span:nth-child(1){
                padding-left: 16px;
                text-align: left;
                width: 30%;
              }
              >span:nth-child(5){
                width: 10%;
              }
            }
            // .item_title{
              
            // }
          }
        }
      }
    }
    .foot{
      margin: 10px 0px;
      background: white;
      padding: 16px;
      display: flex;
      flex-flow: column nowrap;
      font-size: 16px;
      >span{
        >span:nth-child(1){
          font-weight: bold;
          letter-spacing: 1px;
          color: #888;
          margin-right: 6px;
        }
      }
      >span:nth-child(2){
        margin: 6px 0px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Index/Report/textReportetails.vue